module.exports = __webpack_public_path__ + "img/icons B_36.0b318a15.png";